export const ErrorOutline = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      fill="none"
      viewBox="0 0 36 36"
    >
      <g>
        <path
          fill="#fff"
          d="M16.5 22.5h3v3h-3v-3zm0-12h3v9h-3v-9zM17.985 3C9.705 3 3 9.72 3 18c0 8.28 6.705 15 14.985 15C26.28 33 33 26.28 33 18c0-8.28-6.72-15-15.015-15zM18 30c-6.63 0-12-5.37-12-12S11.37 6 18 6s12 5.37 12 12-5.37 12-12 12z"
        ></path>
      </g>
    </svg>
  )
}
